import type { AnimationEventHandler, JSX, MouseEvent } from 'react'

export enum SlideshowAnimation {
	Long = 'long',
	Short = 'short',
}
export interface SlideshowProps {
	readonly children: JSX.Element[]
	readonly className: string
	readonly dataTestId?: string
	readonly hasDotsIndicator?: boolean
	readonly initialAnimation?: SlideshowAnimation
	readonly hasPreload: boolean
	readonly hasLoop?: boolean
	readonly labels?: { previous: string; next: string }
	readonly onSwipe?: () => void
	readonly blockTouchEvents?: boolean
	readonly defaultActiveItemIndex?: number
	readonly onAnimationEnd?: AnimationEventHandler<HTMLDivElement>
}

export interface UseSlideshowLoop {
	handleLoop: (
		fromDirection: SlideshowFromDirection,
		preserveIndex?: boolean
	) => void
}

export interface UpdateSlideshowStylesProps {
	activeItemIndex?: number
	offset?: number
	transitionDuration?: number
}

export enum SlideshowFromDirection {
	Left = 'left',
	Right = 'right',
}

export interface SlideshowIndexDirectionsMap {
	[SlideshowFromDirection.Left]: number
	[SlideshowFromDirection.Right]: number
}

export interface UseSlideshowArrows {
	isArrowPreviousDisabled: boolean
	isArrowNextDisabled: boolean
	handleClick: (
		e: MouseEvent<HTMLButtonElement>,
		direction: SlideshowFromDirection
	) => void
}
